module.exports = __webpack_public_path__ + "static/img/m-a-m-_256.60666d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m-a-m-_256.png
// module id = 0T6n
// module chunks = 0